import Constants from 'Components/ContractGenerator/shared/constants';
import i18n from 'Dictionaries/i18n';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import Product from '../Product';
import styles from './Area.module.scss';
import EnableStep2 from './EnableStep2';

const Area = ({ products, isPackageArea }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');
	const { isLoggedIn = false } = useSelector(contractGeneratorSelectors.getUser);

	const sharedConstants = useSelector(contractGeneratorSelectors.getConstants);
	const extensions = useSelector(contractGeneratorSelectors.getExtensions);
	const { selectedExtensions, selectedRooms, selectedProduct } = useSelector(contractGeneratorSelectors.getDataToSubmit);
	const [showPopup, setShowPopup] = useState(false);

	const getProductOption = product => {
		return product.options[selectedProduct.options[product.id] || product.selectedOption];
	};

	const handleProduct = product => {
		if (getProductOption(product).isForSale) {
			const isStep2Enabled = Cookies.get('enabled') === 'true' || isLoggedIn || false;

			if (!isStep2Enabled) {
				dispatch(
					contractGeneratorOperations.setDataToSubmit({
						selectedProduct: { id: product.id }
					})
				);
				setShowPopup(true);
			} else {
				// Set paymentType to yearly if product cant be monthly
				let overwritePaymentType = {};
				if (!getProductOption(product).canBePayedMonthly) {
					overwritePaymentType = { selectedPaymentType: 'yearly' };
				}

				// Remove extensions that cant be selected due to the set rooms and chosen product
				const overwriteSelectedExtenstions = [...selectedExtensions.ids].filter(extenstionId => {
					if (
						selectedRooms < extensions[extenstionId].displayThresholds.minRooms ||
						selectedRooms > extensions[extenstionId].displayThresholds.maxRooms ||
						!product.extensions.includes(Number(extenstionId))
					) {
						return false;
					}

					return true;
				});

				dispatch(
					contractGeneratorOperations.setDataToSubmit({
						selectedProduct: { id: product.id },
						...overwritePaymentType,
						selectedExtensions: {
							ids: overwriteSelectedExtenstions
						}
					})
				);
				dispatch(contractGeneratorOperations.setActiveStep(Constants.STEPS.STEP2));
			}
		} else {
			window.location.href = `${sharedConstants.COMPANY.INQUIRY_LINK}?lang=${i18n.language}`;
		}
	};

	return (
		<div className={styles.area}>
			<FlexBox alignItems='center' className={styles.header} justifyContent='center'>
				{isPackageArea ? t('pages.step1.products.area.package.headline') : t('pages.step1.products.area.product.headline')}
			</FlexBox>
			<FlexBox alignItems='stretch' className={styles.products}>
				{products
					.filter(product => product.isPackage === isPackageArea)
					.map((product, index) => (
						<Product
							key={product.id}
							description={product.description || {}}
							feeDiscountType={getProductOption(product).setupFee.discount.type}
							feeDiscountValue={getProductOption(product).setupFee.discount.value}
							highlight={product.highlight && index === 0}
							increaseWidth={product.increaseWidth && index === 0}
							isForSale={getProductOption(product).isForSale}
							isSinglePayment={getProductOption(product).isSinglePayment}
							link={product.link || ''}
							options={product.options}
							productDiscountType={getProductOption(product).discount.type}
							productDiscountValue={getProductOption(product).discount.value}
							productOption={getProductOption(product)}
							selectedOption={selectedProduct.options[product.id] || product.selectedOption}
							translationKey={product.key}
							onSelectOption={selectedOption =>
								dispatch(
									contractGeneratorOperations.setDataToSubmit({
										selectedProduct: { options: { [product.id]: selectedOption } }
									})
								)
							}
							onSelectProduct={() => handleProduct(product)}
						/>
					))}
			</FlexBox>
			<EnableStep2
				setShowPopup={setShowPopup}
				showPopup={showPopup}
				onSuccess={() => {
					Cookies.set('enabled', 'true', { path: '' });
					handleProduct(products.find(({ id }) => id === selectedProduct.id));
				}}
			/>
		</div>
	);
};

Area.propTypes = {
	products: PropTypes.array,
	isPackageArea: PropTypes.bool
};

Area.defaultProps = {
	products: [],
	isPackageArea: false
};

export default Area;
